<template>
    <div
        class="text-left max-h-screen w-full max-w-md border ct-border-1 ct-bg-1--alt rounded-xl flex flex-col shadow-xl p-6 space-y-6"
    >
        <div class="w-full flex items-start space-x-2">
            <h2 class="text-left flex-grow ct-text-1 text-lg font-semibold">
                {{ modalData.title }}
            </h2>

            <ButtonCloseSm class="flex-shrink-0" @click="$emit('close')" />
        </div>

        <div class="block sm:hidden">
            <FormSelect
                :label="$t('shared.share_modal.item_to_share')"
                :options="modalData.links"
                :value="selected"
                @change="selectedLink = $event"
            />
        </div>

        <div class="hidden sm:block space-y-4">
            <div
                v-for="link in modalData.links"
                :key="link.value"
                class="w-full flex items-center text-left space-x-3"
            >
                <CardIcon>
                    <component :is="link.icon" />
                </CardIcon>
                <p class="flex-grow">{{ link.label }}</p>
                <div class="space-x-2">
                    <a :href="link.url" target="_blank">
                        <ButtonSecondaryIconMd v-tooltip="$t('shared.share_modal.preview')">
                            <LinkShareIcon />
                        </ButtonSecondaryIconMd>
                    </a>
                    <ButtonSecondaryIconMd
                        v-if="link.code"
                        v-tooltip="$t('shared.share_modal.copy_embed_code')"
                        @click="copyThis(link.code)"
                    >
                        <CodeIcon />
                    </ButtonSecondaryIconMd>
                    <ButtonSecondaryIconMd
                        v-tooltip="$t('shared.share_modal.copy_link')"
                        @click="copyLink(link.url)"
                    >
                        <LinkChainIcon />
                    </ButtonSecondaryIconMd>
                </div>
            </div>
        </div>

        <div class="hidden sm:block">
            <FormDivider />
        </div>

        <FormToggleSm :title="$t('shared.share_modal.shorten_links')" v-model="shortenLinks" />

        <div class="block sm:hidden">
            <FormDivider />
        </div>

        <div class="block sm:hidden space-y-3">
            <a :href="selectedLink.url" target="_blank">
                <ButtonSecondarySm class="w-full">
                    <LinkShareIcon />
                    <span>{{ $t("shared.share_modal.preview") }}</span>
                </ButtonSecondarySm>
            </a>
            <ButtonSecondarySm class="w-full" @click="copyThis(selectedLink.code)">
                <CodeIcon />
                <span>{{ $t("shared.share_modal.copy_embed_code") }}</span>
            </ButtonSecondarySm>
            <ButtonSecondarySm class="w-full" @click="copyLink(selectedLink.url)">
                <LinkChainIcon />
                <span>{{ $t("shared.share_modal.copy_link") }}</span>
            </ButtonSecondarySm>
        </div>
    </div>
</template>

<script>
import { copy } from "@/shared/utils/string";
import { mapActions, mapMutations } from "vuex";
import { ButtonCloseSm, ButtonSecondaryIconMd, ButtonSecondarySm } from "@easy/ui/buttons";
import { FormToggleSm, FormDivider, FormSelect } from "@easy/ui/forms";

import { LinkShareIcon, CodeIcon, LinkChainIcon } from "@easy/ui/icons";
import { CardIcon } from "@easy/ui/cards";

export default {
    components: {
        ButtonCloseSm,
        FormToggleSm,

        FormDivider,
        ButtonSecondaryIconMd,
        LinkShareIcon,
        CardIcon,
        CodeIcon,
        LinkChainIcon,
        FormSelect,
        ButtonSecondarySm,
    },
    props: {
        modalData: Object,
    },
    emits: ["close"],
    data() {
        return {
            shortenLinks: false,
            selected: this.modalData.links[0].value,
        };
    },
    computed: {
        selectedLink() {
            return this.modalData.links.find((link) => link.value === this.selected);
        },
        inputData: {
            get() {
                return this.text;
            },
            set(value) {
                this.$emit("update:text", value);
            },
        },
    },
    methods: {
        ...mapMutations(["showAlert"]),
        ...mapActions(["generateShortLink"]),
        copyLink(url) {
            if (this.shortenLinks) {
                this.generateShortLink(url);
            } else {
                this.copyThis(url);
            }
        },
        copyThis(text) {
            copy(text);
            this.showAlert({
                type: "success",
                title: this.$t("shared.copied"),
            });
        },
    },
};
</script>
